enum ConfluencePages {
  COMPANIES = '43712525',
  DASHBOARD = '43319347',
  DEVICES = '43614211',
  MANUFACTURING = '43581444',
  PROJECTS = '43286580',
  PRIVACY_POLICY = '47939613',
  RUUVI_TAGS = '43122744',
  USERS = '43614229',
  USER_MANUAL = '294913',
  TERMS_OF_SERVICE = '45711364',
  AUTH_SIGN_IN = '99024897',
  CHANGELOG = '68419602',

  INSTALLATION_HEATER_ENTER_CUSTOMER_REFERENCE_INSTRUCTIONS_FI = '347275266',
  INSTALLATION_HEATER_ENTER_CUSTOMER_REFERENCE_INSTRUCTIONS_SE = '347799553',
  INSTALLATION_HEATER_ENTER_CUSTOMER_REFERENCE_INSTRUCTIONS_NO = '347930625',
  INSTALLATION_HEATER_ENTER_CUSTOMER_REFERENCE_INSTRUCTIONS_EN = '348160001',
  INSTALLATION_HEATER_ENTER_CUSTOMER_REFERENCE_INSTRUCTIONS_DE = '348258305',
  INSTALLATION_HEATER_ENTER_CUSTOMER_REFERENCE_INSTRUCTIONS_FR = '348356609',
  INSTALLATION_HEATER_ENTER_CUSTOMER_REFERENCE_INSTRUCTIONS_ES = '348422145',
  INSTALLATION_HEATER_ENTER_CUSTOMER_REFERENCE_INSTRUCTIONS_NL = '348487681',

  INSTALLATION_HEATER_CREATE_NEW_HEATER_INSTRUCTIONS_FI = '348618753',
  INSTALLATION_HEATER_CREATE_NEW_HEATER_INSTRUCTIONS_SE = '348422153',
  INSTALLATION_HEATER_CREATE_NEW_HEATER_INSTRUCTIONS_NO = '348749825',
  INSTALLATION_HEATER_CREATE_NEW_HEATER_INSTRUCTIONS_EN = '348782593',
  INSTALLATION_HEATER_CREATE_NEW_HEATER_INSTRUCTIONS_DE = '348880897',
  INSTALLATION_HEATER_CREATE_NEW_HEATER_INSTRUCTIONS_FR = '347799561',
  INSTALLATION_HEATER_CREATE_NEW_HEATER_INSTRUCTIONS_ES = '348258314',
  INSTALLATION_HEATER_CREATE_NEW_HEATER_INSTRUCTIONS_NL = '347799569',

  VALVE_INSTALL_RUUVITAG_INSTRUCTIONS_FI = '315654156',
  VALVE_INSTALL_RUUVITAG_INSTRUCTIONS_SE = '316112906',
  VALVE_INSTALL_RUUVITAG_INSTRUCTIONS_NO = '315916306',
  VALVE_INSTALL_RUUVITAG_INSTRUCTIONS_EN = '314736682',
  VALVE_INSTALL_RUUVITAG_INSTRUCTIONS_DE = '315817988',
  VALVE_INSTALL_RUUVITAG_INSTRUCTIONS_ES = '315883532',
  VALVE_INSTALL_RUUVITAG_INSTRUCTIONS_FR = '315129888',
  VALVE_INSTALL_RUUVITAG_INSTRUCTIONS_NL = '315752476',

  VALVE_ATTACH_IN_RUUVITAG_INSTRUCTIONS_FI = '315392001',
  VALVE_ATTACH_IN_RUUVITAG_INSTRUCTIONS_SE = '315752449',
  VALVE_ATTACH_IN_RUUVITAG_INSTRUCTIONS_NO = '314933250',
  VALVE_ATTACH_IN_RUUVITAG_INSTRUCTIONS_EN = '315621377',
  VALVE_ATTACH_IN_RUUVITAG_INSTRUCTIONS_DE = '315916289',
  VALVE_ATTACH_IN_RUUVITAG_INSTRUCTIONS_ES = '315686914',
  VALVE_ATTACH_IN_RUUVITAG_INSTRUCTIONS_FR = '315949057',
  VALVE_ATTACH_IN_RUUVITAG_INSTRUCTIONS_NL = '315981825',

  VALVE_ATTACH_OUT_RUUVITAG_INSTRUCTIONS_FI = '314703884',
  VALVE_ATTACH_OUT_RUUVITAG_INSTRUCTIONS_SE = '315162626',
  VALVE_ATTACH_OUT_RUUVITAG_INSTRUCTIONS_NO = '315162633',
  VALVE_ATTACH_OUT_RUUVITAG_INSTRUCTIONS_EN = '315523076',
  VALVE_ATTACH_OUT_RUUVITAG_INSTRUCTIONS_DE = '315097101',
  VALVE_ATTACH_OUT_RUUVITAG_INSTRUCTIONS_ES = '314736658',
  VALVE_ATTACH_OUT_RUUVITAG_INSTRUCTIONS_FR = '316243969',
  VALVE_ATTACH_OUT_RUUVITAG_INSTRUCTIONS_NL = '316276737',

  INSTALL_GENERATOR_ENTER_CUSTOMER_REFERENCE_INSTRUCTIONS_FI = '382959617',
  INSTALL_GENERATOR_ENTER_CUSTOMER_REFERENCE_INSTRUCTIONS_SE = '382992385',
  INSTALL_GENERATOR_ENTER_CUSTOMER_REFERENCE_INSTRUCTIONS_NO = '383090689',
  INSTALL_GENERATOR_ENTER_CUSTOMER_REFERENCE_INSTRUCTIONS_EN = '382959625',
  INSTALL_GENERATOR_ENTER_CUSTOMER_REFERENCE_INSTRUCTIONS_DE = '382959633',
  INSTALL_GENERATOR_ENTER_CUSTOMER_REFERENCE_INSTRUCTIONS_FR = '383221761',
  INSTALL_GENERATOR_ENTER_CUSTOMER_REFERENCE_INSTRUCTIONS_ES = '383287297',
  INSTALL_GENERATOR_ENTER_CUSTOMER_REFERENCE_INSTRUCTIONS_NL = '383352833'
}

export default ConfluencePages
